/**
 * Русское слово «кал» (испражнения) с границами слова — без ложных срабатываний
 * на «калорийный», «калории», «ккал», «кальций» и т.п.
 * Используется в маршрутизации чата и в follow-up чипсах help-чата.
 */
export const RUSSIAN_STOOL_KAL_PATTERN =
  /(^|[^\p{L}])(кал|кала|кале|калом|калу)([^\p{L}]|$)/iu;
